export default "__VITE_ASSET__7dec367d__"